import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'subpage-layout',
  templateUrl: './subpage-layout.component.html',
  styleUrls: ['./subpage-layout.component.scss']
})
export class SubpageLayoutComponent {

  @Input() showBackButton: boolean = false;
  @Input() nativeBack: boolean = false;
  @Input() defaultLink: string = '';

  @Output() back: EventEmitter<void> = new EventEmitter();

}
